export { default as ListadoCuentaCobrar } from "./Listado";
